export const QUERY_KEY_PASSENGER_CHART_ROUTES = 'passenger-chart-routes'
export const QUERY_KEY_PASSENGER_CHART_ROUTE = 'passenger-chart-route'
